<template>
  <div class="app" v-title data-title="富林印迹-广富林文化遗址公园">
    <component :is="headerComponent" :activeIndex="2" />
    <div class="yj-banner rel">
      <img src="@/assets/images/wz-banner.png" class="db wp100" alt="banner">
      <div class="crumbs-nav df align_center justify_end fa_wh box-border">
        <router-link to="/" class="f16 fw">首页</router-link>
        <img src="@/assets/images/arrow-wh-05.png" class="db w20 ml5 mr5" alt="">
        <router-link to="/pages/wanzhuan/index" class="f16 fw">玩转富林</router-link>
        <img src="@/assets/images/arrow-wh-05.png" class="db w20 ml5 mr5" alt="">
        <router-link to="/pages/wanzhuan/wanzhuan-notice" class="f16 fw">游园须知</router-link>
      </div>
      <div class="yj-banner-tit df align_center flex_column justify_center ts fw">
        <div class="f50 ls1 b">玩转富林</div>
        <div class="f17 ls3">Explore Guangfulin</div>
      </div>
      <div class="yj-nav wp100">
        <div class="yj-nav-item df align_center justify_center">
          <div class="yj-nav-box ">
            <router-link to="/pages/wanzhuan/index" class="yj-nav-link db f24">开园时间</router-link>
          </div>
          <div class="yj-nav-box active">
            <router-link to="/pages/wanzhuan/wanzhuan-notice" class="yj-nav-link db f24">游园须知</router-link>
          </div>
          <div class="yj-nav-box">
            <router-link to="/pages/wanzhuan/wanzhuan-problem" class="yj-nav-link db f24">常见问题解答</router-link>

          </div>
        </div>
      </div>
    </div>
    <div class="wz-notice mt50 pb50">
      <div class=" w1200 auto pb50">
        <div class="cell_bk tj f17 wz-notice-text lh20" v-if="data && data.length > 0" v-html="data[0].ContentText">
          
        </div>
      </div>

    </div>
    <component :is="bottomComponent" />
  </div>
</template>

<script>
import Header from '../../components/header.vue'
import Bottom from '../../components/bottom.vue'
import promotionService from '@/services/client/cont/promotion'

export default {
  name: 'app',
  data () {
    return {
      headerComponent: 'Header',
      bottomComponent: 'Bottom',
      code: 'app-wzfl-ryzn-yyxz',
      data: null,
    }
  },
  components: { Header, Bottom,},
  mounted(){
    this.loadData();
  },
  methods:{
    loadData() {
      promotionService.detail(this.code).then(res => {
        if(res.Code == 200) {
          let data = res.Data;
          this.data = data.Items;
        }
      })
    },
  }

}
</script>



// WEBPACK FOOTER //
// src/views/wanzhuan/wanzhuan-notice.vue